<ng-container *ngIf="scorecard">
  <ng-container *ngIf="scorecard.Locked; else normalScorecard">
    <fgbcl-scorecard-locked
      [disabled]="disabled"
      [isSponsorInBody]="isSponsorInBody"
      [scorecard]="scorecard"
    ></fgbcl-scorecard-locked>
  </ng-container>

  <ng-template #normalScorecard>
    <ng-container *ngIf="!!scorecard.Milestone">
      <div
        [ngClass]="{ 'scorecard-linked-shadow': scorecard?.ParentId || isScorecardHasChild }"
        class="scorecard scorecard-milestone scorecard-container col-12 px-0 position-relative scorecard-container-radius"
        (click)="openScorecardDescription()"
      >
        <!--Header-->
        <div class="mb-3">
          <div class="scorecard-count-container w-100 d-flex justify-content-between">
            <div class="d-flex">
              <img
                alt=""
                class="scorecard-image"
                [ngClass]="{ 'scorecard-one-punch-incomplete': !scorecard.Completed }"
                src="{{ scorecard.Image | contentImage: '7' : 'badge' }}"
                [useDefault]="true"
                [loyaltyType]="'badge'"
              />
              <span class="ps-3">
                <h3 class="scorecard-name scorecard-label-ellipsis" id="scorecard-milestone-name">
                  {{ scorecard.Content[0].Name }}
                </h3>
                <p class="scorecard-description scorecard-label-ellipsis mb-2" id="scorecard-milestone-description">
                  {{ scorecard.Content[0].ShortDescription }}
                </p>
              </span>
            </div>
            <div class="scorecard-punchcard-steps" id="scorecard-actions-steps">
              {{ scorecard.Milestone.CustomerValue }}/{{ maxMilestone }}
            </div>
          </div>
        </div>
        <!--Progress bar-->
        <div
          class="d-flex flex-column progress-bar-container"
          [ngClass]="{ 'progress-bar-center': !scorecard.Milestone.DisplayMilestones }"
        >
          <div
            class="progress milestone-progress-bar mx-3 position-relative"
            [ngClass]="{ isMilestoneNotReachedTwoLastest: isMilestoneNotReachedTwoLastest }"
          >
            <div
              id="scorecard-progress-bar"
              class="progress-bar"
              role="progressbar"
              aria-labelledby="scorecard-actions-steps"
              [style.width.%]="currentProgressValue"
              [attr.aria-valuenow]="currentProgressValue"
              aria-valuemin="0"
              [attr.aria-valuemax]="maxMilestone"
            ></div>
          </div>
          <ng-container *ngIf="!scorecard.Milestone.DisplayMilestones">
            <div
              class="milestone-progress-bar-last-circle"
              [ngClass]="{
                'circle-filled': currentProgressValue <= 100,
                'circle-empty': currentProgressValue < 100,
              }"
            ></div>
          </ng-container>
        </div>
        <!--milestone marking and label under progress bar-->
        <ng-container *ngIf="scorecard.Milestone.DisplayMilestones">
          <div class="mx-4 position-relative">
            <ng-container *ngFor="let milestoneSpacing of allMilestoneSpacing; index as i; last as last">
              <!-- <div class="dashed-line position-absolute" [ngStyle]="{ left: milestoneSpacing + '%' }"></div> -->
              <div
                class="milestone-progress-bar-circle"
                [ngClass]="{
                  'circle-filled': milestoneSpacing <= currentProgressValue,
                  'circle-empty': milestoneSpacing > currentProgressValue,
                }"
                [ngStyle]="{
                  left:
                    milestoneSpacing -
                    alignmentOfMilestoneCircle -
                    (last && isMilestoneNotReachedTwoLastest ? alignMilestoneNotReachedTwoLastest : 0) +
                    '%',
                }"
              ></div>
              <div
                class="position-absolute pt-3 pe-1 scorecard-milestone-value"
                [ngStyle]="{
                  left:
                    milestoneSpacing -
                    alignmentOfMilestoneValue -
                    (last && isMilestoneNotReachedTwoLastest ? alignMilestoneNotReachedTwoLastest : 0) +
                    '%',
                }"
              >
                {{ scorecard.Milestone.Milestones[i].Value }}
              </div>
            </ng-container>
          </div>
        </ng-container>
        <!--Footer-->
        <div class="w-100 position-absolute scorecard-progress-footer">
          <div class="scorecard-footer-container">
            <div class="scorecard-prize-border">
              <ng-container
                *ngIf="
                  scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard?.HasCustomerSelectedPrize;
                  else normalFooter
                "
              >
                <span class="scorecard-choose-prize-text" id="scorecard-completed-text">{{
                  'scorecard.footer.choose.prize' | translate
                }}</span>
              </ng-container>

              <ng-template #normalFooter>
                <div class="scorecard-label-ellipsis scorecard-prize">
                  <span class="scorecard-prize-label">{{ 'scorecard.prize' | translate }} </span>
                  <span class="scorecard-prize-text" id="scorecard-completed-text">{{
                    scorecard.Completed && scorecard?.HasCustomerSelectedPrize
                      ? ('scorecard.footer.prize.selected' | translate)
                      : !scorecard.Completed && scorecard.CompleteAction == 6 && !scorecard.HasCustomerSelectedPrize
                        ? ('scorecard.footer.prize.selection' | translate)
                        : scorecard.Content[0].PrizeDescription
                  }}</span>
                </div>
                <ng-container *ngIf="scorecard.Sponsor?.SponsorImage">
                  <div class="sponsor-img-text">
                    <img class="sponsor-img" [src]="scorecard.Sponsor.SponsorImage | contentImage: '30'" />
                  </div>
                </ng-container>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
